import React, { useEffect, useState } from 'react'
import { makeStyles, useTheme } from '@seahorse/ui'
import { TextField, Button } from '@seahorse/ui'
import { queryEmgpt } from '../../Utils/Utils'
import ChatFinePrint from '../../../Components/Common/ChatFinePrint'
const ChatTileComponent: React.FunctionComponent = () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const theme = useTheme()
    const colors = {
        Pending: theme.globallink.colors.DataTurquoise[500],
        Ineligible: theme.globallink.colors.DataOrange[500],
        Cleared: theme.globallink.colors.DataPurple[500],
        Rejected: theme.globallink.colors.DataAmber[600],
        Dark: theme.globallink.colors.Grey[1100],
        Light: theme.globallink.colors.White[500],
        question: theme.globallink.colors.Blue[500],
        answer: theme.globallink.colors.White[500],
    }
    const useStyles = makeStyles({
        container: {
            width: '100%',
            height: '80%',
            padding: '10px',
        },
        container1: {
            overflow: 'auto',
            height: '90%',
            width: '100%',
            backgroundColor: colors.Dark,
            padding: '10px',
        },
        message: {
            margin: '10px 0',
            padding: '8px',
            borderRadius: '4px',
            color: 'white',
            width: 'fit-content',
        },
        question: {
            backgroundColor: colors.question,  // Light purple for questions
            alignSelf: 'flex-start',
            marginLeft: 'auto',
            maxWidth: '60%',
            color: 'white',
        },
        answer: {
            backgroundColor: colors.answer,  // Light green for answers
            alignSelf: 'flex-end',
            marginRight: 'auto',
            maxWidth: '60%',
            color: 'black',


        }
    })

    const classes = useStyles()
    const [newsArticles, setNewsArticles] = useState([])
    const [messageInput, setMessageInput] = useState('')
    const defaultMessage = { question: false, text: "Hello, How can I help you Today?" }
    const [messages, setMessages] = useState([
        defaultMessage,

    ])

    const handleSendMessage = async () => {
        const oldMessages = messages
        setMessages([...oldMessages, { question: true, text: messageInput }])
        const newMessages = ([...oldMessages, { question: true, text: messageInput }])
        setMessageInput('')
        console.log(messageInput)
        try {
            const response = await queryEmgpt(messageInput)
            setMessages([...newMessages, { question: false, text: response }])
        }
        catch (err) { console.log(err) }

    }
    const ClearChat = () => {
        setMessages([defaultMessage])
        setMessageInput('')
    }
    return (
        <>
            <div className={classes.container}>
                <div className="d-flex align-items-center justify-content-between">
                    <h3>EM GPT</h3>
                    {messages.length > 1 && (
                        <Button onClick={ClearChat} className="btn btn-danger btn-sm">
                            Reset Chat
                        </Button>
                    )}
                </div>
                <div className={classes.container1}>
                    {messages.map((msg, index) => (
                        <div
                            key={index}
                            className={`${classes.message} ${msg.question ? classes.question : classes.answer}`}
                        >
                            {msg.text}
                        </div>
                    ))}
                </div>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginTop: '10px'
                }}>
                    <TextField placeholder='Enter the Question.' value={messageInput} onChange={(e) => setMessageInput(e)} endAdornment={<Button onClick={() => handleSendMessage()}>Ask</Button>} />
                </div>
                <ChatFinePrint assistantName="EM GPT" style={{ marginTop: '6px' }} />
            </div>
        </>
    )
}

export default ChatTileComponent
